import { render, staticRenderFns } from "./fileView.vue?vue&type=template&id=2d930c36&scoped=true"
import script from "./fileView.vue?vue&type=script&lang=js"
export * from "./fileView.vue?vue&type=script&lang=js"
import style0 from "./fileView.vue?vue&type=style&index=0&id=2d930c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d930c36",
  null
  
)

export default component.exports